import { render } from "./ParallaxComponent.vue?vue&type=template&id=cfcfa648&ts=true"
import script from "./ParallaxComponent.vue?vue&type=script&lang=ts"
export * from "./ParallaxComponent.vue?vue&type=script&lang=ts"

import "./ParallaxComponent.vue?vue&type=style&index=0&id=cfcfa648&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__